export const Layout = () => import('@/layout/index.vue')

/**
 * 牧行工贸 ERP/MES 路由（由 scripts/erp-gen-pages.cjs 生成）
 * 9 个业务分组各自作为侧边栏一级菜单；页面渲染见 src/erp/ 与 src/views/erp/
 */
const routes = [
  {
    path: '/erp/basic',
    name: 'ErpBasic',
    redirect: '/erp/basic/bom',
    component: Layout,
    meta: { icon: 'Coin', title: '基础数据', roles: ['erp/basic/bom', 'erp/basic/order-bom', 'erp/basic/products', 'erp/basic/accessories', 'erp/basic/materials', 'erp/basic/partners', 'erp/basic/process', 'erp/basic/craft', 'erp/basic/workshop', 'erp/basic/employee', 'erp/basic/warehouse', 'erp/basic/zone', 'erp/basic/equipment', 'erp/basic/dict'], activeMenuTop: '/erp/basic', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'bom',
        name: 'ErpBasicBom',
        component: () => import('@/views/erp/basic/bom.vue'),
        meta: {
          title: '标准 BOM',
          roles: ['erp/basic/bom'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'order-bom',
        name: 'ErpBasicOrderBom',
        component: () => import('@/views/erp/basic/order-bom.vue'),
        meta: {
          title: '订单 BOM',
          roles: ['erp/basic/order-bom'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'products',
        name: 'ErpBasicProducts',
        component: () => import('@/views/erp/basic/products.vue'),
        meta: {
          title: '产品档案',
          roles: ['erp/basic/products'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'accessories',
        name: 'ErpBasicAccessories',
        component: () => import('@/views/erp/basic/accessories.vue'),
        meta: {
          title: '配件档案',
          roles: ['erp/basic/accessories'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'materials',
        name: 'ErpBasicMaterials',
        component: () => import('@/views/erp/basic/materials.vue'),
        meta: {
          title: '物料档案',
          roles: ['erp/basic/materials'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'customers',
        name: 'ErpBasicCustomers',
        component: () => import('@/views/erp/basic/customers.vue'),
        meta: {
          title: '客户档案',
          roles: ['erp/basic/partners'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'suppliers',
        name: 'ErpBasicSuppliers',
        component: () => import('@/views/erp/basic/suppliers.vue'),
        meta: {
          title: '供应商档案',
          roles: ['erp/basic/partners'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'partners',
        name: 'ErpBasicPartners',
        redirect: '/erp/basic/customers',
        meta: {
          title: '客商档案',
          roles: ['erp/basic/partners'],
          activeMenu: '/erp/basic/customers',
          activeMenuTop: '/erp/basic',
          hidden: true,
          keepAlive: false,
          alwaysShow: false
        }
      },
      {
        path: 'process',
        name: 'ErpBasicProcess',
        component: () => import('@/views/erp/basic/process.vue'),
        meta: {
          title: '工序档案',
          roles: ['erp/basic/process'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'craft',
        name: 'ErpBasicCraft',
        component: () => import('@/views/erp/basic/craft.vue'),
        meta: {
          title: '工艺档案',
          roles: ['erp/basic/craft'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'workshop',
        name: 'ErpBasicWorkshop',
        component: () => import('@/views/erp/basic/workshop.vue'),
        meta: {
          title: '车间档案',
          roles: ['erp/basic/workshop'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'employee',
        name: 'ErpBasicEmployee',
        component: () => import('@/views/erp/basic/employee.vue'),
        meta: {
          title: '员工档案',
          roles: ['erp/basic/employee'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'warehouse',
        name: 'ErpBasicWarehouse',
        component: () => import('@/views/erp/basic/warehouse.vue'),
        meta: {
          title: '仓库档案',
          roles: ['erp/basic/warehouse'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'zone',
        name: 'ErpBasicZone',
        component: () => import('@/views/erp/basic/zone.vue'),
        meta: {
          title: '库区管理',
          roles: ['erp/basic/zone'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'equipment',
        name: 'ErpBasicEquipment',
        component: () => import('@/views/erp/basic/equipment.vue'),
        meta: {
          title: '设备档案',
          roles: ['erp/basic/equipment'],
          activeMenuTop: '/erp/basic',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'dict',
        name: 'ErpBasicDict',
        component: () => import('@/views/erp/basic/dict.vue'),
        meta: {
          title: '数据字典',
          roles: ['erp/basic/dict'],
          activeMenuTop: '/erp/basic',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/sales',
    name: 'ErpSales',
    redirect: '/erp/sales/order',
    component: Layout,
    meta: { icon: 'Sell', title: '销售管理', roles: ['erp/sales/contract', 'erp/sales/contract-create', 'erp/sales/order', 'erp/sales/order-new', 'erp/sales/sample', 'erp/sales/sample-create', 'erp/sales/sale-out', 'erp/sales/warning', 'erp/sales/return'], activeMenuTop: '/erp/sales', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'sample',
        name: 'ErpSalesSample',
        component: () => import('@/views/erp/sales/sample.vue'),
        meta: {
          title: '打样任务单',
          roles: ['erp/sales/sample'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'sample-create',
        name: 'ErpSalesSampleCreate',
        component: () => import('@/views/erp/sales/sample-create.vue'),
        meta: {
          title: '新建打样单',
          roles: ['erp/sales/sample-create'],
          activeMenu: '/erp/sales/sample',
          activeMenuTop: '/erp/sales',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'contract',
        name: 'ErpSalesContract',
        component: () => import('@/views/erp/sales/contract.vue'),
        meta: {
          title: '客户合同',
          roles: ['erp/sales/contract'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'contract-create',
        name: 'ErpSalesContractCreate',
        component: () => import('@/views/erp/sales/contract-create.vue'),
        meta: {
          title: '新建客户合同',
          roles: ['erp/sales/contract-create'],
          activeMenu: '/erp/sales/contract',
          activeMenuTop: '/erp/sales',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'order',
        name: 'ErpSalesOrder',
        component: () => import('@/views/erp/sales/order.vue'),
        meta: {
          title: '产品订单',
          roles: ['erp/sales/order'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'order-new',
        name: 'ErpSalesOrderNew',
        component: () => import('@/views/erp/sales/order-new.vue'),
        meta: {
          title: '新建产品订单',
          roles: ['erp/sales/order-new'],
          activeMenu: '/erp/sales/order',
          activeMenuTop: '/erp/sales',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'sale-out',
        name: 'ErpSalesSaleOut',
        component: () => import('@/views/erp/sales/sale-out.vue'),
        meta: {
          title: '销售出库',
          roles: ['erp/sales/sale-out'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'warning',
        name: 'ErpSalesWarning',
        component: () => import('@/views/erp/sales/warning.vue'),
        meta: {
          title: '交期预警',
          roles: ['erp/sales/warning'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'return',
        name: 'ErpSalesReturn',
        component: () => import('@/views/erp/sales/return.vue'),
        meta: {
          title: '退换货处理',
          roles: ['erp/sales/return'],
          activeMenuTop: '/erp/sales',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/purchase',
    name: 'ErpPurchase',
    redirect: '/erp/purchase/request',
    component: Layout,
    meta: { icon: 'ShoppingCart', title: '采购管理', roles: ['erp/purchase/request', 'erp/purchase/order', 'erp/purchase/in', 'erp/purchase/receipt-new'], activeMenuTop: '/erp/purchase', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'request',
        name: 'ErpPurchaseRequest',
        component: () => import('@/views/erp/purchase/request.vue'),
        meta: {
          title: '待采购物料',
          roles: ['erp/purchase/request'],
          activeMenuTop: '/erp/purchase',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'order',
        name: 'ErpPurchaseOrder',
        component: () => import('@/views/erp/purchase/order.vue'),
        meta: {
          title: '采购订单',
          roles: ['erp/purchase/order'],
          activeMenuTop: '/erp/purchase',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'order-create',
        name: 'ErpPurchaseOrderCreate',
        component: () => import('@/views/erp/purchase/order-create.vue'),
        meta: {
          title: '新建采购订单',
          roles: ['erp/purchase/order'],
          activeMenu: '/erp/purchase/order',
          activeMenuTop: '/erp/purchase',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'in',
        name: 'ErpPurchaseIn',
        component: () => import('@/views/erp/purchase/in.vue'),
        meta: {
          title: '采购入库',
          roles: ['erp/purchase/in'],
          activeMenuTop: '/erp/purchase',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'receipt-new',
        name: 'ErpPurchaseReceiptNew',
        component: () => import('@/views/erp/purchase/receipt-new.vue'),
        meta: {
          title: '新建入库单',
          roles: ['erp/purchase/receipt-new'],
          activeMenu: '/erp/purchase/in',
          activeMenuTop: '/erp/purchase',
          hidden: true,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/pda',
    name: 'ErpPda',
    redirect: '/erp/pda/inbound',
    component: Layout,
    meta: { icon: 'Cellphone', title: 'PDA 端', roles: ['erp/pda/inbound'], activeMenuTop: '/erp/pda', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'inbound',
        name: 'ErpPdaInbound',
        component: () => import('@/views/erp/pda/inbound.vue'),
        meta: {
          title: 'PDA 收货',
          roles: ['erp/pda/inbound'],
          activeMenuTop: '/erp/pda',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      }
    ]
  },
  {
    path: '/erp/production',
    name: 'ErpProduction',
    redirect: '/erp/production/mrp',
    component: Layout,
    meta: { icon: 'Cpu', title: '生产管理', roles: ['erp/production/mrp', 'erp/production/workorder', 'erp/production/dispatch', 'erp/production/reportwork', 'erp/production/outsourcing', 'erp/production/material-return'], activeMenuTop: '/erp/production', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'mrp',
        name: 'ErpProductionMrp',
        component: () => import('@/views/erp/production/mrp.vue'),
        meta: {
          title: 'MRP 运算',
          roles: ['erp/production/mrp'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'workorder',
        name: 'ErpProductionWorkorder',
        component: () => import('@/views/erp/production/workorder.vue'),
        meta: {
          title: '工单管理',
          roles: ['erp/production/workorder'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'dispatch',
        name: 'ErpProductionDispatch',
        component: () => import('@/views/erp/production/dispatch.vue'),
        meta: {
          title: '派工+进度看板',
          roles: ['erp/production/dispatch'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'reportwork',
        name: 'ErpProductionReportwork',
        component: () => import('@/views/erp/production/reportwork.vue'),
        meta: {
          title: '报工审工',
          roles: ['erp/production/reportwork'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'outsourcing',
        name: 'ErpProductionOutsourcing',
        component: () => import('@/views/erp/production/outsourcing.vue'),
        meta: {
          title: '外协管理',
          roles: ['erp/production/outsourcing'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'material-return',
        name: 'ErpProductionMaterialReturn',
        component: () => import('@/views/erp/production/material-return.vue'),
        meta: {
          title: '生产退补料',
          roles: ['erp/production/material-return'],
          activeMenuTop: '/erp/production',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/equipment',
    name: 'ErpEquipment',
    redirect: '/erp/equipment/mgmt',
    component: Layout,
    meta: { icon: 'Tools', title: '设备管理', roles: ['erp/equipment/mgmt'], activeMenuTop: '/erp/equipment', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'mgmt',
        name: 'ErpEquipmentMgmt',
        component: () => import('@/views/erp/equipment/mgmt.vue'),
        meta: {
          title: '设备管理',
          roles: ['erp/equipment/mgmt'],
          activeMenuTop: '/erp/equipment',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/warehouse',
    name: 'ErpWarehouse',
    redirect: '/erp/warehouse/stock',
    component: Layout,
    meta: { icon: 'Box', title: '仓储管理', roles: ['erp/warehouse/stock', 'erp/warehouse/stock-lock', 'erp/warehouse/inout', 'erp/warehouse/inventory-check', 'erp/warehouse/dead-stock'], activeMenuTop: '/erp/warehouse', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'stock',
        name: 'ErpWarehouseStock',
        component: () => import('@/views/erp/warehouse/stock.vue'),
        meta: {
          title: '库存查询',
          roles: ['erp/warehouse/stock'],
          activeMenuTop: '/erp/warehouse',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'stock-lock',
        name: 'ErpWarehouseStockLock',
        component: () => import('@/views/erp/warehouse/stock-lock.vue'),
        meta: {
          title: '锁库日志',
          roles: ['erp/warehouse/stock-lock'],
          activeMenuTop: '/erp/warehouse',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'inout',
        name: 'ErpWarehouseInout',
        component: () => import('@/views/erp/warehouse/inout.vue'),
        meta: {
          title: '出入库管理',
          roles: ['erp/warehouse/inout'],
          activeMenuTop: '/erp/warehouse',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'inventory-check',
        name: 'ErpWarehouseInventoryCheck',
        component: () => import('@/views/erp/warehouse/inventory-check.vue'),
        meta: {
          title: '盘点管理',
          roles: ['erp/warehouse/inventory-check'],
          activeMenuTop: '/erp/warehouse',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'dead-stock',
        name: 'ErpWarehouseDeadStock',
        component: () => import('@/views/erp/warehouse/dead-stock.vue'),
        meta: {
          title: '呆滞料查询',
          roles: ['erp/warehouse/dead-stock'],
          activeMenuTop: '/erp/warehouse',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/finance',
    name: 'ErpFinance',
    redirect: '/erp/finance/receivable',
    component: Layout,
    meta: { icon: 'Money', title: '财务报表', roles: ['erp/finance/receivable', 'erp/finance/payroll', 'erp/finance/invoice', 'erp/finance/cost', 'erp/finance/profit', 'erp/finance/reports'], activeMenuTop: '/erp/finance', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'receivable',
        name: 'ErpFinanceReceivable',
        component: () => import('@/views/erp/finance/receivable.vue'),
        meta: {
          title: '应收应付',
          roles: ['erp/finance/receivable'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'payroll',
        name: 'ErpFinancePayroll',
        component: () => import('@/views/erp/finance/payroll.vue'),
        meta: {
          title: '工资核算',
          roles: ['erp/finance/payroll'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'invoice',
        name: 'ErpFinanceInvoice',
        component: () => import('@/views/erp/finance/invoice.vue'),
        meta: {
          title: '开票管理',
          roles: ['erp/finance/invoice'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'cost',
        name: 'ErpFinanceCost',
        component: () => import('@/views/erp/finance/cost.vue'),
        meta: {
          title: '工单成本',
          roles: ['erp/finance/cost'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'profit',
        name: 'ErpFinanceProfit',
        component: () => import('@/views/erp/finance/profit.vue'),
        meta: {
          title: '订单毛利',
          roles: ['erp/finance/profit'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'reports',
        name: 'ErpFinanceReports',
        component: () => import('@/views/erp/finance/reports.vue'),
        meta: {
          title: '报表中心',
          roles: ['erp/finance/reports'],
          activeMenuTop: '/erp/finance',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/kanban',
    name: 'ErpKanban',
    redirect: '/erp/kanban/workshop',
    component: Layout,
    meta: { icon: 'DataAnalysis', title: '数据看板', roles: ['erp/kanban/workshop', 'erp/kanban/quality', 'erp/kanban/equip-status', 'erp/kanban/dashboard', 'erp/kanban/extra'], activeMenuTop: '/erp/kanban', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'workshop',
        name: 'ErpKanbanWorkshop',
        component: () => import('@/views/erp/kanban/workshop.vue'),
        meta: {
          title: '车间生产看板',
          roles: ['erp/kanban/workshop'],
          activeMenuTop: '/erp/kanban',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'quality',
        name: 'ErpKanbanQuality',
        component: () => import('@/views/erp/kanban/quality.vue'),
        meta: {
          title: '质量管理',
          roles: ['erp/kanban/quality'],
          activeMenuTop: '/erp/kanban',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'equip-status',
        name: 'ErpKanbanEquipStatus',
        component: () => import('@/views/erp/kanban/equip-status.vue'),
        meta: {
          title: '设备状态',
          roles: ['erp/kanban/equip-status'],
          activeMenuTop: '/erp/kanban',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'dashboard',
        name: 'ErpKanbanDashboard',
        component: () => import('@/views/erp/kanban/dashboard.vue'),
        meta: {
          title: '经营总览',
          roles: ['erp/kanban/dashboard'],
          activeMenuTop: '/erp/kanban',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'extra',
        name: 'ErpKanbanExtra',
        component: () => import('@/views/erp/kanban/extra.vue'),
        meta: {
          title: '补充看板',
          roles: ['erp/kanban/extra'],
          activeMenuTop: '/erp/kanban',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
  {
    path: '/erp/system',
    name: 'ErpSystem',
    redirect: '/erp/system/roles',
    component: Layout,
    meta: { icon: 'Setting', title: '系统配置', roles: ['erp/system/roles', 'erp/system/permission', 'erp/system/approval', 'erp/system/sysparams'], activeMenuTop: '/erp/system', hidden: false, keepAlive: false, alwaysShow: true },
    children: [
      {
        path: 'roles',
        name: 'ErpSystemRoles',
        component: () => import('@/views/erp/system/roles.vue'),
        meta: {
          title: '角色配置',
          roles: ['erp/system/roles'],
          activeMenuTop: '/erp/system',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'permission',
        name: 'ErpSystemPermission',
        component: () => import('@/views/erp/system/permission.vue'),
        meta: {
          title: '权限配置',
          roles: ['erp/system/permission'],
          activeMenuTop: '/erp/system',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'approval',
        name: 'ErpSystemApproval',
        component: () => import('@/views/erp/system/approval.vue'),
        meta: {
          title: '审批配置',
          roles: ['erp/system/approval'],
          activeMenuTop: '/erp/system',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'sysparams',
        name: 'ErpSystemSysparams',
        component: () => import('@/views/erp/system/sysparams.vue'),
        meta: {
          title: '系统参数',
          roles: ['erp/system/sysparams'],
          activeMenuTop: '/erp/system',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
      {
        path: 'notify',
        name: 'ErpSystemNotify',
        component: () => import('@/views/erp/system/notify.vue'),
        meta: {
          title: '站内信',
          roles: ['erp/system/notify'],
          activeMenuTop: '/erp/system',
          hidden: false,
          keepAlive: true,
          alwaysShow: false
        }
      },
    ]
  },
]

export default routes
